export default __webpack_public_path__ + "cb6ab11d7c0d4e22c1a75a355e56f1cc.png";